export class ConvertUtils {
    /**
     * Converts the seconds number to minutes or hour to five characters max with unit
     * Example : converts number "6917" to string "01h55"
     * @param {number} value
     * @return {string}
     */
    public static convertSecondToTime(value: number): string {
        let time: string;
        let min: number;
        let sec: number;
        if (value >= 3600) {
            const hour: number = Math.floor(value / 3600);
            min = Math.floor((value - hour * 3600) / 60);
            time = hour.toString().concat('h ', min.toString(), 'min');
        } else if (value < 3600 && value >= 60) {
            min = Math.floor(value / 60);
            sec = value % 60;
            time = min.toString().concat('min ', sec.toString(), 's');
        } else {
            time = value.toString().concat('s');
        }
        return time;
    }

    /**
     * Converts the number given as cents to float which represents euro and cast it to string
     * Example : converts number "530" to string "5,30"
     * @param {number} value
     * @return {string}
     */
    public static convertCentsToEuros(value: number): string {
        value = value / 100;
        return value.toFixed(2).toString().replace('.', ',');
    }

    /**
     * Converts the kilo number to mega or giga and return a string with unit
     * Example : converts "38949796" to string 37,15 Go"
     * @param {number} value
     * @return {string}
     */
    public static convertKiloToMegaOrGiga(value: number): string {
        let i = 0;
        const unit: string[] = ['Ko', 'Mo', 'Go'];
        if (value < 1024) {
            return value.toString().concat(' ', unit[i]);
        } else {
            while (value > 1024) {
                value = value / 1024;
                i = i + 1;
            }
            let fixedValue: string = value.toFixed(2).toString();
            if (fixedValue.endsWith('0')) {
                fixedValue = fixedValue.slice(0, -1);
            }
            return fixedValue.replace('.', ',').concat(' ', unit[i]);
        }
    }
}
